export const CONTACT_EMAIL = 'codeofmario@gmail.com'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/code-of-mario'
export const LINKEDIN_LABEL = 'linkedin.com/company/code-of-mario'
export const GITHUB_URL = 'https://github.com/codeofmario'
